// src/services/tmdb.js
const TMDB_API_KEY = '0592f640a218a24309ffc9cfaba3da1b';
const TMDB_TOKEN = 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwNTkyZjY0MGEyMThhMjQzMDlmZmM5Y2ZhYmEzZGExYiIsIm5iZiI6MTc0MDg0MTcyMi4zNjMwMDAyLCJzdWIiOiI2N2MzMjJmYTZlNzY4MDkwMDc2ZGYxZTIiLCJzY29wZXMiOlsiYXBpX3JlYWQiXSwidmVyc2lvbiI6MX0.Z3VC2gsCTc59iaL7enfT5E-I44etAEDVPMFtQ-gYEg4';
const TMDB_BASE_URL = 'https://api.themoviedb.org/3';

class TMDBService {
  constructor() {
    this.apiKey = TMDB_API_KEY;
    this.token = TMDB_TOKEN;
  }

  async searchContent(query, type = 'multi') {
    try {
      const response = await fetch(
        `${TMDB_BASE_URL}/search/${type}?api_key=${this.apiKey}&query=${encodeURIComponent(query)}&language=pt-BR`,
        {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      const data = await response.json();
      return data.results;
    } catch (error) {
      console.error('Erro ao buscar no TMDB:', error);
      return [];
    }
  }

  async getMovieDetails(movieId) {
    try {
      const response = await fetch(
        `${TMDB_BASE_URL}/movie/${movieId}?api_key=${this.apiKey}&language=pt-BR&append_to_response=credits,videos,images`,
        {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar detalhes do filme:', error);
      return null;
    }
  }

  async getTVDetails(tvId) {
    try {
      const response = await fetch(
        `${TMDB_BASE_URL}/tv/${tvId}?api_key=${this.apiKey}&language=pt-BR&append_to_response=credits,videos,images`,
        {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar detalhes da série:', error);
      return null;
    }
  }

  async getSeasonDetails(tvId, seasonNumber) {
    try {
      const response = await fetch(
        `${TMDB_BASE_URL}/tv/${tvId}/season/${seasonNumber}?api_key=${this.apiKey}&language=pt-BR`,
        {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar detalhes da temporada:', error);
      return null;
    }
  }

  async getEpisodeDetails(tvId, seasonNumber, episodeNumber) {
    try {
      const response = await fetch(
        `${TMDB_BASE_URL}/tv/${tvId}/season/${seasonNumber}/episode/${episodeNumber}?api_key=${this.apiKey}&language=pt-BR`,
        {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar detalhes do episódio:', error);
      return null;
    }
  }

  // Função para extrair o nome do filme/série da string
  extractTitle(name) {
    // Remove qualidade e informações técnicas
    let title = name
      .replace(/\b(?:SD|HD|FHD|FullHD|Full HD|4K|1080p?|720p?|265|HEVC|H265|H\.265)\b/gi, '')
      .replace(/\[.*?\]/g, '') // Remove texto entre colchetes
      .replace(/\(.*?\)/g, '') // Remove texto entre parênteses
      .trim();

    // Para séries, remove informação de episódio
    const seriesMatch = title.match(/^(.*?)(?:\s+S\d+E\d+)/i);
    if (seriesMatch) {
      title = seriesMatch[1].trim();
    }

    return title;
  }

  // Função para buscar metadata para um item
  async getMetadata(name, type = 'multi') {
    const title = this.extractTitle(name);
    const results = await this.searchContent(title, type);
    
    if (!results || results.length === 0) return null;
    
    // Pega o primeiro resultado mais relevante
    const bestMatch = results[0];
    
    // Busca detalhes completos baseado no tipo
    if (bestMatch.media_type === 'movie' || type === 'movie') {
      return await this.getMovieDetails(bestMatch.id);
    } else if (bestMatch.media_type === 'tv' || type === 'tv') {
      return await this.getTVDetails(bestMatch.id);
    }
    
    return null;
  }

  getImageUrl(path, size = 'original') {
    if (!path) return null;
    return `https://image.tmdb.org/t/p/${size}${path}`;
  }
}

export default new TMDBService(); 